module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel04_1280_1280_vi-58d260b605b5dcf96789f1ca0638f94e.jpg";